var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dot-spinner"},_vm._l((_vm.totalDots),function(dotIndex){return _c('div',{key:dotIndex,staticClass:"dot-spinner__dot"})}))}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2072f591","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/spinner/BaseDotSpinner.vue
// module id = null
// module chunks = 